module.exports = __webpack_public_path__ + "static/media/red-hat-brand-logo.3b87f5c1.png";